export default "__VITE_ASSET__BZ6RSxD5__"